interface EmptyStateProps {
  emoji: string;
  title: string;
  subtitle: string;
  cta?: string;
  ctaAction?: () => void;
}

export function EmptyState({ emoji, title, subtitle, cta, ctaAction }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <span className="empty-state-emoji">{emoji}</span>
      <p className="empty-state-title">{title}</p>
      <p className="empty-state-subtitle">{subtitle}</p>
      {cta && ctaAction && (
        <button className="btn btn-primary mt-2" onClick={ctaAction}>
          {cta}
        </button>
      )}
    </div>
  );
}
